import { writable, get } from 'svelte/store'
import { routerStore } from '../stores/router-store.js'
import { authStore } from '../stores/auth-store.js'
import { serviceWorker } from '../helpers/service-worker.js'

export const projectsStore = writable({
	projectMap: {}
})

export function projectsStoreInit() {
	projectsStoreGetSWProjects()
	projectsStoreSetSWListener()
	projectsStoreGetProjectsUpdates()
}


function projectsStoreGetSWProjects() {
	serviceWorker.active.postMessage({
		action: 'getAllAssets',
		store: 'project'
	})
}


function projectsStoreSetSWListener() {
	navigator.serviceWorker.addEventListener('message', e => {
		if(e.data.action === 'databaseUpdated' && e.data.store === 'project') {
			projectsStore.update(projectsStoreData => {
				projectsStoreData.projectMap[e.data.data.id] = e.data.data
				return projectsStoreData
			})
		}
	})
}

export async function projectsStoreGetProjectsUpdates() {

	/*console.log('projects:created_by=eq.'+ (supabase.auth.user()).id)

	const mySubscription = supabase
		.from('projects')
		.on('*', payload => {
			console.log('Change received!', payload)
		})
		.subscribe()*/

	const { data, error } = await supabase
		.from('projects')
		.select()

	if(error) {
		console.log(error)
	} else {
		data.forEach(project => {

			if(serviceWorker && serviceWorker.active) {
				serviceWorker.active.postMessage({
					action: 'updateDatabase',
					store: 'project',
					data: project
				})
			}
		})
	}

	return data
}

export async function projectsStoreNew() {
	const { data, error } = await supabase
		.from('projects')
		.insert([{
			created_by: (supabase.auth.user()).id
		}])

	if(error) {
		console.log(error)
	}

	projectsStoreGetProjectsUpdates()

	return data
}

export async function projectsStoreUpdateTitle({ id, title }) {
	const { data, error } = await supabase
		.from('projects')
		.update({
			title,
			title_updated: (new Date()).toISOString() 
		})
		.match({ id })

	if(error) {
		console.log(error)
	}

	projectsStoreGetProjectsUpdates()

	return data
}

export async function projectsStoreDelete({ id }) {
	const { data, error } = await supabase
		.from('projects')
		.delete()
		.match({ id })

	if(error) {
		console.log(error)
	}

	return data
}